export const NotFoundPage = () => {
  return (
    <h1>
      404
      <br />
      NOT FOUND
    </h1>
  );
};
